import { PersistentDataService } from '@services/PersistentDataService'
import { defineStore } from 'pinia'
import type { MapOptions } from 'src/models/MapOptions'
import type { ViewOptions } from 'src/models/ViewOptions'

interface State {
  viewOptions: ViewOptions
  mapOptions: MapOptions
}

const defaultLayerOptions: Partial<MapOptions> = {
  isMunicipiosVisible: false,
  isCoastlineVisible: true
}

const defaultMapOptions: MapOptions = {
  elevation: 1,
  opacity: 0.5,
  blur: 0,
  simplify: false
}

const defaultViewOptions: ViewOptions = {
  isLeyendaVisible: false
}

export const useMosaicStore = defineStore('mosaic', {
  state: (): State => ({
    viewOptions: structuredClone(defaultViewOptions),
    mapOptions: structuredClone({
      ...defaultMapOptions,
      ...defaultLayerOptions
    })
  }),

  getters: {
    opacity: (state) => state.mapOptions.opacity,
    blur: (state) => state.mapOptions.blur
  },

  actions: {
    SET_DEFAULT_LAYER_OPTIONS() {
      this.mapOptions = {
        ...this.mapOptions,
        ...defaultLayerOptions
      }
    },
    SET_DEFAULT_OPTIONS() {
      this.mapOptions = structuredClone({
        ...this.mapOptions,
        ...defaultMapOptions
      })
      this.viewOptions = structuredClone(defaultViewOptions)
    },
    SET_USER_MAP_OPTIONS() {
      this.mapOptions =
        PersistentDataService.getOptions('mosaicMapOptions') || this.mapOptions
    },
    SET_USER_VIEW_OPTIONS() {
      this.viewOptions =
        PersistentDataService.getOptions('mosaicViewOptions') ||
        this.viewOptions
    }
  }
})
